import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './RestaurantsField.module.scss';

const RestaurantsField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="restaurantsLabel" theme="neutralLight" size="xs" />
			<div className={style.restaurantsList}>
				{dishForFullInfo?.restaurantsDishes.length
					? dishForFullInfo.restaurantsDishes.map((el) => {
							return (
								<div key={el.restaurantId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.restaurantName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default RestaurantsField;
